import { render, staticRenderFns } from "./TestResultsTable.vue?vue&type=template&id=3c7c6b62&scoped=true&"
import script from "./TestResultsTable.vue?vue&type=script&lang=ts&"
export * from "./TestResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TestResultsTable.vue?vue&type=style&index=0&id=3c7c6b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c6b62",
  null
  
)

export default component.exports